// extracted by mini-css-extract-plugin
export default {"chatWidget":"nBMXJ","mobile":"RxEj4","expanded":"+6uur","left":"_4v4Ot","minimizedChat":"kBk8-","right":"CBZHl","fixed":"+Km3p"};